<template>
    <FormControl
        disabled
        label="Email"
    >
        <TextInput
            disabled
            :value="user.email"
        />
    </FormControl>

    <FormControl
        required
        label="First name"
        :error="
            errors.getValidationError(
                RequestBodyKeyEnum.App_MyProfile_FirstName,
            )
        "
    >
        <TextInput
            :disabled="readonly"
            :name="RequestBodyKeyEnum.App_MyProfile_FirstName"
            :value="user.firstName"
            required
        />
    </FormControl>

    <FormControl
        label="Last name"
        :error="
            errors.getValidationError(RequestBodyKeyEnum.App_MyProfile_LastName)
        "
    >
        <TextInput
            :disabled="readonly"
            :name="RequestBodyKeyEnum.App_MyProfile_LastName"
            :value="user.lastName"
        />
    </FormControl>

    <FormControl
        required
        label="Display Timezone (dashboard only)"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_MyProfile_DisplayTimezone,
            )
        "
    >
        <TimezoneSelector
            :disabled="readonly"
            :name="RequestBodyKeyEnum.App_MyProfile_DisplayTimezone"
            :value="selectedTimezone"
            :useBookingFormThemeCssVariables="false"
            :required="true"
            @onTimezoneSelectionChange="
                (event) => (selectedTimezone = event.value)
            "
        />
    </FormControl>

    <div v-if="user.profilePicture">
        <FormControl label="Current profile picture">
            <Image
                :src="user.profilePicture.url"
                class="max-h-36 w-auto mx-auto border border-stone-200"
            />
        </FormControl>
    </div>
    <FormControl
        v-if="!readonly"
        label="Profile picture"
        :error="
            errors.getValidationError(
                RequestFileKeyEnum.App_MyProfile_ProfilePicture,
            )
        "
    >
        <FileInput
            :name="RequestFileKeyEnum.App_MyProfile_ProfilePicture"
            :accept="UserProfilePictureFileData.allowedMimeTypes"
            :maxSizeInBytes="UserProfilePictureFileData.maxFileSizeInBytes"
            iconName="card-image"
        />
    </FormControl>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import User from '@/App/User/Entity/User'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import FileInput from '@/Shared/Component/Forms/FileInput.vue'
    import { UserProfilePictureFileData } from '@/Shared/AutoGenerated/Main'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import TimezoneSelector from '@/BookingForm/BookingForm/Component/TimezoneSelector.vue'
    import {
        RequestBodyKeyEnum,
        RequestFileKeyEnum,
    } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import Image from '@/Shared/Component/Image.vue'

    const props = defineProps({
        user: {
            type: Object as PropType<User>,
            required: true,
        },
        companyUser: {
            type: Object as PropType<CompanyUser>,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const selectedTimezone = ref<string>(props.companyUser.displayTimezone)
</script>
